import { requireAnySystemPermission } from '@juvare/contact-management/backend/features/permissions/shared';
import { UserState } from '@juvare/platform-sdk-react/types';
import { ConfigurationPageDef } from '@juvare/platform-sdk-react/ui/features/classifiers';
import { DepartmentAdminPage } from '../DepartmentAdminPage';
import { HanRolesAdminPage } from '../HanRolesAdminPage';
import { JobTitleAdminPage } from '../JobTitleAdminPage';

export const getHanConfigurationPages = (userState: UserState): ConfigurationPageDef[] => {
    if (!requireAnySystemPermission(userState, 'manage-all-classifiers', 'manage-client-classifiers')) {
        return [];
    }

    const pages: ConfigurationPageDef[] = [];

    if (requireAnySystemPermission(userState, 'manage-all-classifiers')) {
        pages.push({
            label: 'HAN Roles',
            name: 'hanRoles',
            path: 'han-roles',
            groupLabel: 'Other',
            component: HanRolesAdminPage,
        });
    }

    if (requireAnySystemPermission(userState, 'manage-client-classifiers')) {
        pages.push(
            {
                label: 'Job Title',
                name: 'jobTitle',
                path: 'job-title',
                groupLabel: 'Other',
                component: JobTitleAdminPage,
            },
            {
                label: 'Department',
                name: 'department',
                path: 'department',
                groupLabel: 'Other',
                component: DepartmentAdminPage,
            },
        );
    }

    return pages;
};
